export enum WebGLExtension{
    OES_vertex_array_object,
    ANGLE_instanced_arrays,
    OES_texture_half_float,
    OES_texture_half_float_linear,
    OES_texture_float,
    OES_element_index_uint,
    OES_texture_float_linear,//allows linear filtering with floating-point pixel types for textures.
    EXT_color_buffer_half_float,//Render BufferHalf float color
    EXT_shader_texture_lod,
    WEBGL_depth_texture,
    EXT_sRGB,
    EXT_color_buffer_float,
    EXT_texture_filter_anisotropic,
    WEBGL_compressed_texture_s3tc,
    WEBGL_compressed_texture_s3tc_srgb,
    WEBGL_compressed_texture_pvrtc,
    WEBGL_compressed_texture_etc1,
    WEBGL_compressed_texture_etc,
    WEBGL_compressed_texture_astc,
    OES_standard_derivatives,
}